import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { CookieService } from 'ngx-cookie-service'

import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { ErrorComponent } from './error/error.component'
import { DashboardModule } from './features/dashboard/dashboard.module'
import { DisclosuresModule } from './features/disclosures/disclosures.module'
import { DistributionsModule } from './features/distributions/distributions.module'
import { FundLiteratureModule } from './features/fund-literature/fund-literature.module'
import { FundManagementModule } from './features/fund-management/fund-management.module'
import { NavTabGroupModule } from './features/nav-tab-group/nav-tab-group.module'
import { OverviewModule } from './features/overview/overview.module'
import { PerformanceModule } from './features/performance/performance.module'
import { PortfolioModule } from './features/portfolio/portfolio.module'
import { PriceModule } from './features/price/price.module'
import { SharedModule } from './features/shared/shared.module'
import { TestFontStylesComponent } from './features/test-font-styles/test-font-styles.component'
import { ProfileComponent } from './profile/profile.component'
import { SecYieldPage } from './sec-yield-page/sec-yield-page.component'
import { CentralContentService } from './services/content/central-content.service'
import { FundUtilityService } from './services/fund-utility/fund-utility.service'

export function retrieve_content(centralContentService: CentralContentService) {
  return () => centralContentService.load()
}

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    ErrorComponent,
    SecYieldPage,
    TestFontStylesComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CommonModule,
    DashboardModule,
    OverviewModule,
    PerformanceModule,
    PriceModule,
    PortfolioModule,
    DistributionsModule,
    FundManagementModule,
    FundLiteratureModule,
    NavTabGroupModule,
    DisclosuresModule,
    SharedModule,
  ],
  providers: [
    CookieService,
    FundUtilityService,
    CentralContentService,
    {
      provide: APP_INITIALIZER,
      useFactory: retrieve_content,
      deps: [CentralContentService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
